// Hooks
import React, { createContext, useContext, useState } from "react";

export const ChannelFilterContext = createContext<any>(null);

export function useChannelFilter() {
  return useContext(ChannelFilterContext);
}

export function ChannelFilterProvider({ children }: { children: any }) {
  const [currentFilter, setCurrentFilter] = useState<"c" | "h" | "">("");
  const [currentSearch, setCurrentSearch] = useState<string | null>(null);

  return (
    <ChannelFilterContext.Provider
      value={{
        currentFilter,
        setCurrentFilter,
        currentSearch,
        setCurrentSearch,
      }}
    >
      {children}
    </ChannelFilterContext.Provider>
  );
}
